import React from 'react';
import ReactDOM from 'react-dom';

const modalContext = React.createContext();

function Modal({ children, onModalClose }) {
  const modalRef = React.createRef();
  const handleTabKey = e => {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], input[type="email"], select'
    );
    const firstElement = focusableModalElements[0];
    const lastElement =
      focusableModalElements[focusableModalElements.length - 1];
    
    if (!e.shiftKey && document.activeElement === lastElement) {
      firstElement.focus();
      return e.preventDefault();
    }

    if (e.shiftKey && document.activeElement === firstElement) {
      lastElement.focus();
      e.preventDefault();
    }
  };
  const keyListenersMap = new Map([[27, onModalClose], [9, handleTabKey]]);
  React.useEffect(() => {
    function keyListener(e) {
      const listener = keyListenersMap.get(e.keyCode);
      return listener && listener(e);
    }
    document.addEventListener("keydown", keyListener);

    return () => document.removeEventListener("keydown", keyListener);
  });


  return ReactDOM.createPortal(
    <div className="modal modal-back" role="dialog" aria-modal="true">
      <div className="modal-dialog" ref={modalRef}>
        <modalContext.Provider value={{ onModalClose }}>
          {children}
        </modalContext.Provider>
      </div>
    </div>,
    document.body
  );
}

Modal.Header = function ModalHeader(props) {
  const { onModalClose } = React.useContext(modalContext);

  return (
    <div className="modal-header">
      <button id="modal-close" type="button" className="close" aria-label="Close" onClick={onModalClose}>
        <span aria-hidden="true">×</span>
      </button>
      {props.children}
    </div>
  );
};

Modal.Body = function ModalBody(props) {
  return <div className="modal-body">{props.children}</div>;
};

Modal.Footer = function ModalFooter(props) {
  return <div className="modal-footer">{props.children}</div>;
};

Modal.Footer.CloseBtn = function CloseBtn(props) {
  const { onModalClose } = React.useContext(modalContext);
  return (
    <button
      {...props}
      className="tertiary-button"
      title="close modal"
      onClick={onModalClose}
    />
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/modal-new.js